export default "__VITE_ASSET__Cf$10hea__"